import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bradcrumb-simple" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 2,
  class: "separator"
}

import { svgIcon } from "@/common/components";

export interface BreadcrumbItemType {
  key: string;
  label: string;
  url?: string;
  external?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'breadcrumb-simple',
  props: {
    items: {},
    active: {},
    showHome: { type: Boolean },
    urlHome: {},
    maxLenght: { default: 25 }
  },
  setup(__props: any) {

const props = __props;

function subs(item: string) {
  if (item.length <= props.maxLenght) return item;
  return item.substring(0, props.maxLenght) + "...";
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", null, [
      (__props.showHome && __props.urlHome)
        ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
            _createVNode(_component_router_link, { to: __props.urlHome }, {
              default: _withCtx(() => [
                _createVNode(_unref(svgIcon), {
                  icon: "home-line",
                  size: "1.25rem"
                })
              ]),
              _: 1
            }, 8, ["to"]),
            _cache[0] || (_cache[0] = _createElementVNode("span", null, " / ", -1))
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          (item.url)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: item.url,
                target: item.external ? '_blank' : '_self',
                class: _normalizeClass(["link-url", {
							active: __props.active === item.key,
						}])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(subs(item.label)), 1)
                ]),
                _: 2
              }, 1032, ["to", "target", "class"]))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(["link-active", {
							active: __props.active === item.key,
						}])
              }, _toDisplayString(subs(item.label)), 3)),
          (index < __props.items.length - 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " / "))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})